import {combineReducers} from 'redux';
import genericReducer from 'common/reducers/generic-reducer';
import chapterReportReducer from 'storyboard/reducers/chapter-report-reducer';
import dataReducer from 'storyboard/reducers/data-reducer';

// The keys of the reducers in the object
// passed to combineReducers must match
// exactly the top level attributes in
// the initial data from window.storyboard.
// Anything that doesn't match will be
// ignored by Redux, with a warning.
export default combineReducers({
  dashboards: genericReducer,
  data: dataReducer,
  enums: genericReducer,
  report: chapterReportReducer,
  settings: genericReducer,
});
